<div class="menu-container">
  <h2 class="menu-title">{{ title }}</h2>
  <div class="menu-items-list">
    @for(item of items; track item.id) {
      <app-product-card
        [id]="item.id"
        [title]="item.name"
        [description]="item.description"
        [price]="item.price/100"
        [imageUrl]="item.imageUrl"
        [isFavorite]="item.isFavorite ?? false"
        [productData]="item"
      ></app-product-card>
    }
  </div>
</div>
